<template>
  <div
    class="top-nav flex align-center"
    ref="topNav">
    <router-link
      class="top-nav-logo"
      to="/"
      ref="topNavLogo">
      <img
        src="@/assets/img/common/logo.png"
        alt="">
    </router-link>

    <div
      class="el-menu-box"
      ref="elMenuBox">
      <el-menu
        v-if="rootMenuStyle !== 1"
        :active-text-color="variables.menuActiveText"
        :default-active="activeMenu"
        mode="horizontal"
        @select="handleSelect"
        ref="elMenuRef">
        <div
          v-for="item in permission_routes"
          :key="item.path"
          class="nav-item">
          <app-link :to="resolvePath(item)">
            <el-menu-item
              v-if="!item.hidden"
              :index="item.path">
              <i :class="item.meta.icon" v-if="!!(item.meta && item.meta.icon)"></i>
              <span>{{ item.meta ? item.meta.title : item.children[0].meta.title }}</span>
            </el-menu-item>
          </app-link>
        </div>
      </el-menu>
    </div>

    <div class="right-menu" ref="rightMenu">
      <div class="flex align-center">
        <el-dropdown
          :hide-on-click="false"
          placement="bottom-start"
          trigger="click">
          <div class="avatar-wrapper pr-4">
            <span>邀请入驻</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="py-2.5 hover-focus-cancel">
              <InvitationQRcode class="flex flex-col items-center w-52 py-5" />
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown
          ref="dropdownParkRef"
          :hide-on-click="false"
          trigger="click">
          <div class="avatar-wrapper pr-4">
            <span>{{ currentParkName }}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              :disabled="row.parkId === currentParkId"
              v-for="row in parkList"
              :key="row.parkId">
              <span
                class="block w-full py-1"
                @click="postChangeCurrentUserManagePark(row)">{{ row.parkName }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown
          ref="dropdownRef"
          style="padding: 0;"
          :hide-on-click="false"
          trigger="click">
          <!-- 用户头像 -->
          <div class="avatar-wrapper pr-4">
            <img
              v-if="!!userId"
              class="user-avatar"
              :src="noAvatar"
              alt=""
              v-jw-load-img="getMediaURL(avatar)">
            <span>{{ name }}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <!-- 这里最小宽度140px，是设计稿宽度 -->
          <el-dropdown-menu
            style="min-width:140px;padding: 0;"
            slot="dropdown">
            <li class="list-style-none">
              <el-dropdown-item class="hover-focus-cancel">
                <div class="top-nav-logout" @click="logout">
                  <span class="fs-14">退出</span>
                  <i class="iconfont icon-tuichu"></i>
                </div>
              </el-dropdown-item>
            </li>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <modPassword
      v-if="modPasswordDialog.show"
      v-model="modPasswordDialog.show"></modPassword>
    <DownloadDialog
      v-if="folderDownloadDialog.show"
      v-model="folderDownloadDialog.show"
      :exData="folderDownloadDialog.exData"></DownloadDialog>
  </div>
</template>

<script>
import InvitationQRcode from '@/components/invitationQRcode'
import modPassword from '@/components/_dialog/modPassword'
import DownloadDialog from '@/components/_dialog/downloadDialog'
import AppLink from './Sidebar/Link'
import BScroll from '@better-scroll/core'
import MouseWheel from '@better-scroll/mouse-wheel'
import variables from '@/styles/variables.scss'
import debounce from 'lodash/debounce'
import { mapGetters, mapState } from 'vuex'
import { isExternal } from '@/utils/validate'

BScroll.use(MouseWheel)
export default {
  name: 'Topbar',
  components: {
    InvitationQRcode,
    AppLink,
    modPassword,
    DownloadDialog
  },
  data() {
    return {
      modPasswordDialog: {
        show: false
      },
      scroll: null,
      debounceInitScroll: null,
      messageList: [],
      messageDisabled: false,
      showBadge: false,
      dropdownShow: true,
      noAvatar: require('../../assets/img/common/no_avatar@2x.png'), // 默认头像
      booRoleList: false,
      parkList: [] // 当前用户可以管理的所有园区
    }
  },
  computed: {
    ...mapGetters([
      'avatar',
      'name',
      'booUserPlatform',
      'rootMenuStyle',
      'currentParkId',
      'currentParkName',
      'userId'
    ]),
    ...mapState({
      folderDownloadDialog: (state) => state.uploadStore.folderDownloadDialog
    }),
    permission_routes() {
      return this.$store.getters.permission_routes.filter(route => !route.hidden)
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      // if (meta.activeMenu) {
      //   return meta.activeMenu
      // }
      // 如果是首页，首页高亮
      // if (path === '/dashboard') {
      //   return '/'
      // }
      // 如果不是首页，高亮一级菜单
      const activeMenu = '/' + path.split('/')[1]
      return activeMenu
    },
    variables() {
      return variables
    },
    sidebar() {
      return this.$store.state.app.sidebar
    },
    roleList() {
      return this.$store.state.user.roleList
    },
    roleId: {
      get() {
        return this.$store.state.user.roleId
      },
      set(val) {
        // 这里不要去更新roleId
        // this.$store.commit('user/SET_ROLE_ID', val)
      }
    },
    roleName() {
      return this.$store.state.user.roleName
    },
    resizeCount() {
      return this.$store.state.app.resizeCount
    },
    webConfig() {
      return this.$store.state.common.webConfig
    },
    frontConfig() {
      return this.$store.state.common.frontConfig
    },
    objProjectTarget() {
      return this.$store.state.user.objProjectTarget
    },
    PCList() {
      return Array.isArray(this.objProjectTarget['1']) ? this.objProjectTarget['1'] : []
    }
  },
  async mounted() {
    this.fetchCurrentUserManagePark()
    this.initCurrentRoutes()
    await this.$nextTick()
    this.initScroll()

    this.debounceInitScroll = debounce(this.initScroll, 200)
  },
  methods: {
    // 通过当前路径找到二级菜单对应项，存到store，用来渲染左侧菜单
    initCurrentRoutes() {
      const { path } = this.$route
      let route = this.permission_routes.find(
        item => item.path === '/' + path.split('/')[1]
      )
      // 如果找不到这个路由，说明是首页
      if (!route) {
        route = this.permission_routes.find(item => item.path === '/')
      }

      if (route) {
        this.$store.commit('permission/SET_CURRENT_ROUTES', route)
        this.setSidebarHide(route)
      }
    },
    resolvePath(item) {
      // 如果是个完成的url直接返回
      if (isExternal(item.path)) {
        return item.path
      }
      // 如果是首页，就返回重定向路由
      if (item.path === '/') {
        const path = item.redirect || item.path
        return path
      }

      // 如果有子项，默认跳转第一个子项路由
      let path = ''
      /**
       * item 路由子项
       * parent 路由父项
       */
      const getDefaultPath = (item, parent) => {
        // 如果path是个外部链接（不建议），直接返回链接，存在个问题：如果是外部链接点击跳转后当前页内容还是上一个路由内容
        if (isExternal(item.path)) {
          path = item.path
          return
        }
        // 第一次需要父项路由拼接，所以只是第一个传parent
        if (parent) {
          path += (parent.path + '/' + item.path)
        } else {
          path += ('/' + item.path)
        }
        // 如果还有子项，继续递归
        if (item.children) {
          getDefaultPath(item.children[0])
        }
      }

      if (item.children) {
        getDefaultPath(item.children[0], item)
        return path
      }

      return item.path
    },
    handleSelect(key) {
      const index = this.permission_routes.findIndex(item => item.path === key)

      try {
        if (index !== -1) {
          this.adjust(this.permission_routes[index].id)
        }
      } catch (err) {
      }
    },
    // 设置侧边栏的显示和隐藏
    setSidebarHide(route) {
      if (!route.children || route.children.length === 1) {
        this.$store.dispatch('app/toggleSideBarHide', true)
      } else {
        this.$store.dispatch('app/toggleSideBarHide', false)
      }
    },
    modPassword() {
      this.modPasswordDialog.show = true
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.replace(`/login`)
    },
    handlePersonal() {
      this.$refs.dropdownRef?.hide()
      this.$router.push({ name: 'Personal' })
    },
    initScroll() {

      const topNavLogoWidth = this.$refs.topNavLogo.$el.offsetWidth
      const rightMenuWidth = this.$refs.rightMenu.offsetWidth

      // 2px：浏览器差异
      this.$refs.elMenuBox.style.width = `calc(100% - ${topNavLogoWidth + rightMenuWidth + 2}px)`

      // 菜单为侧边样式时不实例化BScroll
      if (this.rootMenuStyle === 1) return

      if (!this.scroll) {
        this.scroll = new BScroll(this.$refs.elMenuBox, {
          scrollX: true,
          scrollY: false,
          click: true,
          probeType: 3,
          mouseWheel: true
        })

        if (this.activeMenu) {
          this.handleSelect(this.activeMenu)
        }
      } else {
        this.scroll.refresh()
      }
    },
    adjust(tabId) {
      const viewportWidth = this.$refs.elMenuBox.clientWidth
      const tabListWidth = this.$refs.elMenuRef.$el.clientWidth
      const minTranslate = Math.min(0, viewportWidth - tabListWidth)
      const middleTranslate = viewportWidth / 2
      const items = this.$refs.elMenuRef.$el.children
      let width = 0
      this.permission_routes.every((item, index) => {
        if (item.id === tabId) {
          return false
        }
        width += items[index].clientWidth
        return true
      })
      let translate = middleTranslate - width
      translate = Math.max(minTranslate, Math.min(0, translate))
      this.scroll.scrollTo(translate, 0, 300)
    },
    // 角色选择：
    async handleRoleSelect(val) {
      if (val === this.roleId) {
        return
      }
      this.$refs.dropdownRef?.hide()
      await this.$store.dispatch('user/changeUserDefaultRole', val)
    },
    // 获取当前用户可以管理的所有园区
    async fetchCurrentUserManagePark() {
      const { code, data } = await this.$fetch('/api/park/getCurrentUserManagePark', {}, 'get')
      if (code === 20000) {
        this.parkList = Array.isArray(data) ? data : []
      }
    },
    // 切换当前用户可以管理的园区
    async postChangeCurrentUserManagePark(row) {
      this.$refs.dropdownParkRef?.hide()
      await this.$store.dispatch('user/changeCurrentUserManagePark', row.parkId)
    }
  },
  beforeDestroy() {
    this.scroll && this.scroll.destroy()
  },
  watch: {
    resizeCount: {
      handler: function(newVal) {
        this.debounceInitScroll()
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
